import { useEffect, useState } from "react";
import { executeCode } from "./api";
import "./ide.css";
import SuccessSubmit from "./SuccessSubmit";
import TestFailed from "./TestFailed";
import axios from "axios";
import { FormatCodingQuestion } from "../../../../utils/utils";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../utils/loader/loader";
import { POST_HINT, POST_RUN_CODE } from "../../../../utils/api";
import { apiRequest } from "../../../../api/apiRequest";

const Output = ({ editorRef, language, challengeContent, questionID, selectedType, backToMainComponent }) => {
  const nav = useNavigate();
  const [output, setOutput] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [loading, setLoading] = useState(false);
  const [moreSuggestion, setMoreSuggestion] = useState("");

  const [hintClicked, setHintClicked] = useState(false);
  const [moreHint, setMoreHint] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

//   const runCode = async () => {
//   const sourceCode = editorRef.current.getValue();
//   if (!sourceCode) return;

//   try {
//     setIsLoading(true);

//     const response = await fetch(POST_RUN_CODE, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         code: sourceCode,
//         language: language
//       }),
//     });

//     const result = await response.json();

//       setOutput(result.output ? result.output.split("\n") : result.error);
//     setSuggestion("");
//     setHintClicked(false);
//     localStorage.removeItem("submit-error");

//       result.error ? setIsError(true) : setIsError(false);

//   } catch (error) {
//     setToastState({
//       show: true,
//       message:
//         "An error occurred: " + (error.message || "Unable to run code"),
//       type: "error",
//     });
//   } finally {
//     setIsLoading(false);
//   }
// };
 
const runCode = async () => {
  const sourceCode = editorRef.current.getValue();
  if (!sourceCode) return;

  setIsLoading(true);

  const result = await apiRequest("post", POST_RUN_CODE, {
    code: sourceCode,
    language: language,
  });

  setIsLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: "An error occurred: " + (result.message || "Unable to run code"),
      type: "error",
    });
    return;
  }

  const data = result.data;
  setOutput(data.output ? data.output.split("\n") : data.error);
  setSuggestion("");
  setHintClicked(false);
  localStorage.removeItem("submit-error");

  data.error ? setIsError(true) : setIsError(false);
};

const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };

  // const handleShowSuggestion = async () => {
  //   setMoreSuggestion("");
  //   setMoreHint(true);
  //   const sourceCode = editorRef.current.getValue();
  //   if (!sourceCode) {
  //     setToastState({
  //       show: true,
  //       message: "Please select question first",
  //       type: "error",
  //     });
  //     return;
  //   }
  //   setHintClicked(true);
  //   setLoading(true);
  //   const payLoad = { code: sourceCode, problem_statement: selectedType === "new_code" ? challengeContent?.description : challengeContent  };

  //   const token = localStorage.getItem("access_token") || null;
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //     "Content-Type": "application/json",
  //   };

  //   try {
  //     const resp = await axios.post(
  //       POST_HINT,
  //       payLoad,
  //       {
  //         headers,
  //         withCredentials: true,
  //       }
  //     );

  //     if (resp?.data) {
  //       setLoading(false);
  //       const suggestionList = resp?.data?.suggestions;
  //       setSuggestion(suggestionList);
  //       setOutput("");
  //       return;
  //     } else {
  //       setLoading(false);
  //       setToastState({
  //         show: true,
  //         message: "Unable to fetch response!",
  //         type: "error",
  //       });
  //       return;
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     if (error.status === 401) {
  //       setToastState({
  //         show: true,
  //         message: error.response.data.detail || "Please try again.",
  //         type: "error",
  //       });
  //       setTimeout(() => {
  //         nav("/");
  //       }, 1000);

  //       return;
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const getMoreSuggestion = async () => {
  //   const sourceCode = editorRef.current.getValue();
  //   if (!sourceCode) {
  //     setToastState({
  //       show: true,
  //       message: "Please select question first",
  //       type: "error",
  //     });
  //     return;
  //   }
  //   setHintClicked(true);
  //   setLoading(true);
  //   const payLoad = { code: sourceCode, problem_statement: selectedType === "new_code" ? challengeContent?.description : challengeContent  };

  //   const token = localStorage.getItem("access_token") || null;
  //   const headers = {
  //     Authorization: `Bearer ${token}`,
  //     "Content-Type": "application/json",
  //   };

  //   try {
  //     const resp = await axios.post(
  //       POST_HINT,
  //       payLoad,
  //       {
  //         headers,
  //         withCredentials: true,
  //       }
  //     );

  //     if (resp?.data) {
  //       const suggestionList = resp?.data?.suggestions;
  //       setMoreSuggestion(suggestionList);
  //       setMoreHint(false);

  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //       setToastState({
  //         show: true,
  //         message: "Unable to fetch response!",
  //         type: "error",
  //       });
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     if (error.status === 401) {
  //       setToastState({
  //         show: true,
  //         message: error.response.data.detail || "Token expired.",
  //         type: "error",
  //       });
  //       setTimeout(() => {
  //         nav("/");
  //       }, 1000);

  //       return;
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleShowSuggestion = async () => {
  setMoreSuggestion("");
  setMoreHint(true);
  const sourceCode = editorRef.current.getValue();
  if (!sourceCode) {
    setToastState({
      show: true,
      message: "Please select question first",
      type: "error",
    });
    return;
  }
  setHintClicked(true);
  setLoading(true);

  const payLoad = {
    code: sourceCode,
    problem_statement:
      selectedType === "new_code" ? challengeContent?.description : challengeContent,
  };

  const result = await apiRequest("post", POST_HINT, payLoad);

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Unable to fetch response!",
      type: "error",
    });
    return;
  }

  const suggestionList = result.data?.suggestions;
  setSuggestion(suggestionList);
  setOutput("");
};
  const getMoreSuggestion = async () => {
  const sourceCode = editorRef.current.getValue();
  if (!sourceCode) {
    setToastState({
      show: true,
      message: "Please select question first",
      type: "error",
    });
    return;
  }
  setHintClicked(true);
  setLoading(true);

  const payLoad = {
    code: sourceCode,
    problem_statement:
      selectedType === "new_code" ? challengeContent?.description : challengeContent,
  };
  const result = await apiRequest("post", POST_HINT, payLoad);

  setLoading(false);

  if (!result.success) {
    setToastState({
      show: true,
      message: result.message || "Unable to fetch response!",
      type: "error",
    });
    return;
  }

  const suggestionList = result.data?.suggestions;
  setMoreSuggestion(suggestionList);
  setMoreHint(false);
};
  useEffect(() => {
    setOutput(null);
    setSuggestion("");
    setMoreSuggestion("");
    setHintClicked(false);
    setMoreHint(false);
    setIsError(false);
  }, [challengeContent]);

  return (
    <>
      <div className="w-100 editor-output">
        <div className="w-100 editor-header">
          <div className="tooltip-wrapper">
            {!hintClicked ? (
              <div className="hint-icon" onClick={handleShowSuggestion}>
                <img src="/assets/images/hint_bulb-removebg-preview.png" />
                <span className="fz18">Hint</span>
              </div>
            ) : (
              <div className="hint-icon" onClick={handleShowSuggestion}>
                <img src="/assets/images/image (1).png" />
                <span className="fz18">Hint</span>
              </div>
            )}
            {/* <span className="tooltip-text">Click for hint</span> */}
          </div>

          <button
            className="ms-auto btn btn-run"
            disabled={isLoading}
            onClick={runCode}
          >
            {isLoading ? "Running..." : "Run Code"}
          </button>
          <SuccessSubmit
            editorRef={editorRef}
            challengeContent={challengeContent}
            questionID={questionID}
            selectedType={selectedType}
            backToMainComponent={backToMainComponent}
            language={language}
          />
        </div>
        <div
          className="w-100 editor-output__content"
          style={{
            color: hintClicked
              ? "black"
              : !hintClicked && isError
              ? "red"
              : "black",
            border: "1px solid",
            // borderColor: isError ? "red" : "#333",
            borderColor: hintClicked
              ? "#333"
              : !hintClicked && isError
              ? "red"
              : "#333",
          }}
        >
          {output ? (
            <>
              {" "}
              <label className="m-0 fw500">Output:</label>
              {isError ? <span style={{color:"red"}}> {output}</span> : output}
            </>
          ) : suggestion ? (
            <>
              {[...suggestion, ...moreSuggestion].map((line, i) => (
                <div
                  key={i}
                  dangerouslySetInnerHTML={{
                    __html: FormatCodingQuestion(line),
                  }}
                />
              ))}

              {moreHint ? (
                <div className="prblm-st__footer mt-4">
                  <button
                    className="ms-auto btn-solid--start"
                    onClick={getMoreSuggestion}
                  >
                    More...
                  </button>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            'Click "Run Code" to see the output here'
          )}
        </div>
        <Loader show={loading} />
        <ToastMessage
          show={toastState.show}
          onClose={() => setToastState({ show: false, message: "", type: "" })}
          message={toastState.message}
          type={toastState.type}
        />
      </div>
      {showErrorModal && <TestFailed handleClose={handleCloseErrorModal} />}
    </>
  );
};

export default Output;
